module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0101.jpg?v=e3292c00";